import { BreadAccount } from "breadcommon";
import { firestoreDeleteAccountById } from "../firebaseio/firestoreIo";
import { useContext, useState } from "react";
import { UserContext } from "../firebaseio/UserContext";
import { AccountsContext } from "../firebaseio/AccountsContext";
import { lineWobble } from "ldrs";
import { callFirebaseFunction } from "../firebaseio/firebaseFunctions";
import { RyeModalContent, useRyeModal } from "../rye/RyeModal";
import { buildClasses } from "../utils/buildClasses";

lineWobble.register();

export function DeleteAccountModal({
  account,
  onCancel,
}: {
  account: BreadAccount;
  onCancel?: () => void;
}): JSX.Element {
  const { closeModal } = useRyeModal();
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const user = useContext(UserContext);
  const accounts = useContext(AccountsContext);

  if (deleteInProgress) {
    return (
      <RyeModalContent
        title="Deleting account"
        showCloseX={false}
        actionButtons={[]}
        content={
          <div
            className={buildClasses(
              "flex",
              "flex-col",
              "items-center",
              "gap-6",
              "py-6",
              "w-[24rem]",
            )}
          >
            <l-line-wobble size="150" speed="2" color="#7d57ff"></l-line-wobble>
            <div className={buildClasses("text-on-surface-500", "text-sm")}>
              Deleting account, hang tight...
            </div>
          </div>
        }
      />
    );
  }

  return (
    <RyeModalContent
      title={`Delete "${account.name}"?`}
      actionButtons={[
        {
          text: "Cancel",
          vibe: "subdued",
          variant: "outlined",
          close: !onCancel,
          action: () => {
            if (onCancel) {
              onCancel();
            }
          },
        },
        {
          text: "Delete account",
          vibe: "danger",
          variant: "filled",
          close: false,
          action: async () => {
            if (!user) return;
            setDeleteInProgress(true);

            // remove account from firebase
            try {
              await firestoreDeleteAccountById(
                user.uid,
                account,
                Array.from(accounts.values()),
                true,
              );
            } catch (error) {
              console.log(error);
              setDeleteInProgress(false);
              return;
            }

            // remove unused items & institutions from plaid & firebase
            await callFirebaseFunction("RemoveUnusedItemsAndInstitutions", {});
            closeModal();
          },
        },
      ]}
      content={
        <div
          className={buildClasses(
            "text-sm",
            "text-on-surface-500",
            "w-[24rem]",
          )}
        >
          Are you sure you want to delete this account? This will unlink the
          account and permanently delete all of its transactions and historical
          data. This action cannot be undone.
        </div>
      }
    />
  );
}
